module.exports = __webpack_public_path__ + "static/logo-grupo-familia-f96bb952980b3cbf75bfdec8076acefd.svg";